import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { TuiTextfieldControllerModule, TuiTextareaModule, TuiInputModule } from '@taiga-ui/legacy';
import { TuiButton, TuiHint } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';
import { ListModule } from '@src/app/shared/list';
import { SearchChatsModule } from '@src/app/shared/search-chats';

import { ForwardComponent } from './forward.component';

@NgModule({
  declarations: [ForwardComponent],
  imports: [
    CommonModule,
    FormsModule,
    ListModule,
    MatButtonModule,
    MatIconModule,
    SearchChatsModule,
    TuiButton,
    TuiInputModule,
    TuiTextareaModule,
    TuiTextfieldControllerModule,
    TranslateModule,
    ...TuiHint,
  ],
  exports: [ForwardComponent],
})
export class ForwardModule {}
